import { t } from "@/lib/localization";
import { LomdaV3Page } from "@/lib/utils/lomdaV3/types";

export const pageLabel = (index: number) =>
    t("lomda-v3-editor.pages.page-label", undefined, { number: index + 1 });

/** "Page 2 · Intro" in the UI language, for editor menus. */
export const pageName = (page: Pick<LomdaV3Page, "title">, index: number) =>
    page.title
        ? t("lomda-v3-editor.block.page-with-title", undefined, {
              page: pageLabel(index),
              title: page.title,
          })
        : pageLabel(index);
